import Image from 'next/image';
import React from 'react';

import { make as NativeCarouselCmp } from '../../../../shared/carousel/view/components/NativeCarouselCmp.mjs';
import { CommonImage } from '../../../../shared/types/CommonVM';
import { NewsArticle } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/Featured.module.scss';
import carouselIndicatorStyles from '../styles/FeaturedCarouselIndicator.module.scss';

import FeaturedItemCmp from './FeaturedItemCmp';

interface FeaturedCmpProps {
  news_articles_data: NewsArticle[];
  redirect_icon: CommonImage;
  wave_icon: CommonImage;
  read_article_label: string;
  title: string;
}

function FeaturedCmp({
  news_articles_data,
  redirect_icon,
  wave_icon,
  read_article_label,
  title,
}: FeaturedCmpProps): React.ReactElement | null {
  if (title.length === 0) return null;

  return (
    <div className={styles['container']}>
      <div className={styles['title-container']}>
        <Image
          src={wave_icon.path}
          width={50}
          height={8}
          alt={wave_icon.alt_text}
          quality={100}
        />
        <h2 className={styles['title']}>{title}</h2>
        <Image
          src={wave_icon.path}
          width={50}
          height={8}
          alt={wave_icon.alt_text}
          quality={100}
        />
      </div>
      <NativeCarouselCmp
        delay={4000}
        class_name={styles['carousel-container']}
        autoplay
        show_indicators
        are_indicators_clickable
        carousel_indicator_styles={carouselIndicatorStyles}
        carousel_item_wrapper_class={styles['carousel-item']}
      >
        {news_articles_data.map((news_article) => (
          <FeaturedItemCmp
            key={news_article.content}
            news_article={news_article}
            redirect_icon={redirect_icon}
            read_article_label={read_article_label}
          />
        ))}
      </NativeCarouselCmp>
    </div>
  );
}

export default FeaturedCmp;
